import React from "react";
import { connect } from "react-redux";
import GridviewWithFilteringComponent from "../components/GridviewWithFilteringComponent";

import { IdentityProfile, Policies, Profile } from "../types/model";
import { getProfiles } from "../actions/CMS/profileActions";
import { ProfilesColumns } from "../constants/tableColumns";
import NoAccessComponent from "../components/NoAccessComponent";
import PageLoader from "../components/PageLoader";
import ProfileModalComponent from "../components/ProfileModalComponent";

interface State {
  profiles: Profile[];
  isLoading: boolean;
  showModal: boolean;
  selectedProfile: Profile | null;
}

interface Props {
  i18n: any;
  profile: IdentityProfile;
}

class ProfilesContainer extends React.Component<any, State> {
  state = {
    profiles: [],
    isLoading: true,
    showModal: false,
    selectedProfile: null,
  };

  onRowClick = (row: any) => {
    var selectedProfile = row.original;
    this.setState({ selectedProfile, showModal: true });
  };

  onModalClose = () => {
    this.setState({ selectedProfile: null, showModal: false });
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    var profiles = await getProfiles();
    this.setState({ isLoading: false });

    this.setState({
      selectedProfile: profiles[0],
      profiles,
    });
  }

  render() {
    const { profiles, selectedProfile } = this.state;
    const { i18n } = this.props;

    const claims = this.props.profile ? this.props.profile.roles[0].claims : [];
    var isValid = claims.some((c: any) => [Policies.ProfileView].includes(c));

    return this.state.isLoading ? (
      <PageLoader />
    ) : isValid ? (
      <div>
        <GridviewWithFilteringComponent
          columns={ProfilesColumns(i18n)}
          data={profiles}
          routeName="Profielen"
          title={i18n.profiles}
          buttonName=""
          disableButton={true}
          onRowClick={this.onRowClick}
        />
        {this.state.showModal && (
          <ProfileModalComponent
            selectedProfile={selectedProfile}
            i18n={i18n}
            onClose={this.onModalClose}
          />
        )}
      </div>
    ) : (
      <NoAccessComponent />
    );
  }
}

const mapStateToProps = (state: any): Props => {
  return {
    i18n: state.i18n,
    profile: state.profile,
  };
};

export default connect(mapStateToProps, null)(ProfilesContainer);
